import { render, staticRenderFns } from "./FinancialTableCostHeadersWarning.vue?vue&type=template&id=68bab76d&scoped=true&"
import script from "./FinancialTableCostHeadersWarning.vue?vue&type=script&lang=js&"
export * from "./FinancialTableCostHeadersWarning.vue?vue&type=script&lang=js&"
import style0 from "./FinancialTableCostHeadersWarning.vue?vue&type=style&index=0&id=68bab76d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bab76d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VIcon,VTooltip})
